export enum InnerWallType {
  threeway,
  lProfile,
}
